import { Box, IconButton, Tooltip } from '@mui/material';
import { Delete, Edit, Preview } from '@mui/icons-material';
import { useValue } from '../../../context/ContextProvider';
import { clearPoint, deletePoint } from '../../../actions/point';
import { useNavigate } from 'react-router-dom';

const PointsActions = ({ params }) => {
  const { _id, lng, lat, price, title, description, pointTags, images, uid } = params.row;
  const {
    dispatch,
    state: { currentUser, updatedPoint, addedImages, images: newImages },
  } = useValue();

  const navigate = useNavigate();
  const handleEdit = () => {
    if (updatedPoint) {
      clearPoint(dispatch, currentUser, addedImages, updatedPoint);
    } else {
      clearPoint(dispatch, currentUser, newImages);
    }
    dispatch({ type: 'UPDATE_LOCATION', payload: { lng, lat } });
    dispatch({
      type: 'UPDATE_DETAILS',
      payload: { price, title, description, pointTags },
    });
    dispatch({ type: 'UPDATE_IMAGES', payload: images });
    dispatch({ type: 'UPDATE_UPDATED_POINT', payload: { _id, uid } });
    dispatch({ type: 'UPDATE_SECTION', payload: 2 });
    navigate('/');
  };
  return (
    <Box>
      <Tooltip title="View point details">
        <IconButton
          onClick={() => dispatch({ type: 'UPDATE_POINT', payload: params.row })}
        >
          <Preview />
        </IconButton>
      </Tooltip>
      <Tooltip title="Edit this point">
        <IconButton onClick={handleEdit}>
          <Edit />
        </IconButton>
      </Tooltip>
      <Tooltip title="Delete this point">
        <IconButton
          onClick={() => deletePoint(params.row, currentUser, dispatch)}
        >
          <Delete />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default PointsActions;